import { Box, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { ChromePicker } from "react-color"
import { useLocalization } from "../../providers/LocalizationProvider"

const ColorPickerField = ({ value, onChange, error, required, label }) => {
    const [open, setOpen] = useState(false)
    const { voiceiiTags } = useLocalization()

    return (
        <Box className="e-color-picker-container">
            {/* Input-like container */}
            <Typography className="e-asset-label">
                {voiceiiTags(label)}
                {required && <span style={{ color: "#d32f2f" }}>{" *"}</span>}
            </Typography>
            <Box
                className={`e-color-picker-input ${error ? "e-color-picker-input--error" : ""}`}
                onClick={() => setOpen(true)}
            >
                {/* Color swatch */}
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        backgroundColor: value || "#ffffff",
                        flexShrink: 0,
                    }}
                />

                {/* Hex value */}
                <TextField
                    value={value || "#ffffff"}
                    variant="standard"
                    required={required}
                    InputProps={{ disableUnderline: true, readOnly: true }}
                    className="e-color-picker-hex"
                />
            </Box>

            {/* Picker popover */}
            {open && (
                <Box className="e-color-picker-popover">
                    {/* Click outside overlay */}
                    <Box className="e-color-picker-overlay" onClick={() => setOpen(false)} />

                    <Box className="e-color-picker-panel">
                        <ChromePicker
                            color={value || "#ffffff"}
                            onChange={(color) => onChange(color.hex)}
                        />
                    </Box>
                </Box>
            )}

            {/* Error */}
            {error && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    {error}
                </Typography>
            )}
        </Box>
    )
}

export default ColorPickerField
